<template>
    <v-card
        color="transparent"
        :loading="isLoading"
        :disabled="isLoading"
        class="mx-4"
        elevation="0"
        style="height: 86vh; overflow-y: scroll; overflow-x: hidden;"
    >
        <v-row>
            <v-col v-for="day, index in getDaysInMonthUTC" :index="index" cols="12" md="4" :key="index">
                <PunchDailyView :day="day" :punch="getPunch(day)" />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'
import PunchDailyView from './PunchInDailyView.vue'

export default {
    data: () => ({
        orderedPunches: {},
    }),
    components: {
        PunchDailyView,
    },
    computed: {
        getDaysInMonthUTC() {
            var date = new Date(Date.UTC(this.dateFilter.getFullYear(), this.dateFilter.getMonth(), 1));
            var days = [];
            while (date.getUTCMonth() === this.dateFilter.getMonth()) {
                days.push(new Date(date));
                date.setUTCDate(date.getUTCDate() + 1);
            }
            return days;
        },
        ...mapState('punchIn', ['dateFilter', 'punches', 'isLoading']),
    },
    methods: {
        getPunch(day){
            let formattedDay = day.toISOString().split('T')[0]
            return this.orderedPunches[formattedDay]
        }
    },
    watch: {
        punches: {
            handler() {
                this.orderedPunches = {}
                this.punches.forEach(element => {
                    this.orderedPunches[element.date] = element
                });
            },
            immediate: true,
        },
    }
}
</script>
